import { combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import BillingPortalReducer from '../features/BillingPortal/BillingPortalSlice';
import AuthReducer from '../features/AuthSlice/AuthSlice';
export const rootReducer = combineReducers({
  auth: AuthReducer,
  billingPortal: BillingPortalReducer
});

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/usage/usage-with-typescript#define-typed-hooks
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;